module.exports = __webpack_public_path__ + "img/icon-question-rating-skin-star.8ba6848e.svg";